































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import { DataStore, DataItem } from '@/utils';

import * as I from '@/interfaces';
import * as U from '@/utils';

import exceljs from 'exceljs';
import AxAPI from '@/api';
import moment from 'moment';

class State {
  listCompanyCode: I.CodeData[];
  listDeptCodeA: I.CodeData[];
  listDeptCodeB: I.CodeData[];
  listUserStatus: I.CodeData[];

  empno: string;
  userName: string;
  cardNo: string;

  constructor() {
    this.listCompanyCode = [];
    this.listDeptCodeA = [];
    this.listDeptCodeB = [];
    this.listUserStatus = [];
    this.empno = '';
    this.userName = '';
    this.cardNo = '';
  }

  get cleared() {
    return (
      [this.listCompanyCode, this.listDeptCodeA, this.listDeptCodeB, this.listUserStatus]
        .map(x => x.length > 0)
        .filter(x => x === true).length === 0 &&
      this.empno.length === 0 &&
      this.userName.length === 0
    );
  }
}

class DialogState {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: unknown[];
  headers: unknown[];
  items: unknown[];
  callback: () => Promise<void>;

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.callback = async () => {};
  }
}

enum TabKind {
  Access,
  Door,
  Sensor,
  System
}

@Component
class ApiImpl extends Mixins(AxPage) {
  currentTab!: TabKind;
  API!: AxAPI;

  async execHistorySearch(packet: I.PacketHistorySearch) {
    this.setLoading(true);
    const result = await this.API.call.user.historySearch(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      console.log('결과:', result.data);
      return result.data;
    }
  }
}

interface HistorySearchHeader {
  num?: number;
}

@Component
class DataItemImpl extends Vue {
  currentTab!: TabKind;
  dataItems: DataItem<unknown, State>[] = [
    {
      name: '출입',
      store: new DataStore<HistorySearchHeader & I.History>({
        headers: {
          num: { text: '순번', sortable: false },
          updateTime: { text: '발생일자', width: 120 },
          name: '성명',
          telNo: '전화번호',
          empNo: '사원번호',
          userStatus: '상태',
          companyName: '회사',
          deptNameA: '사업장',
          deptNameB: '부서',
          dutyNameA: '직위',
          uid: '카드번호',
          periodFrom: { text: '시작일자', width: 120 },
          periodTo: { text: '종료일자', width: 120 },
          updateBy: '수정자'
        }
      }),
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentTab];
  }
}

@Component
class SelectDialogImpl extends Mixins(AxPage) {
  currentTab!: TabKind;
  dialogState!: DialogState;
  pageInfo!: I.UserHistoryPageInfo;
  zoneCode!: number;
  ignoreWatch!: number;
  dataItem!: DataItem<unknown, State>;

  openCodeSelectDialog(title: string, name: string) {
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    const items = ((this.pageInfo as unknown) as { [name: string]: I.CodeData[] })[name];
    const selected = ((this.dataItem.state as unknown) as {
      [name: string]: I.CodeData[];
    })[name];

    const callback = async () => {
      const selected = this.dialogState.selected as I.CodeData[];
      ((this.dataItem.state as unknown) as { [name: string]: I.CodeData[] })[
        name
      ] = selected.sort((a, b) => a.code.localeCompare(b.code));
    };
    return this.openSelectDialog(title, headers, items, selected, callback);
  }

  openSelectDialog(
    title: string,
    headers: unknown[],
    items: unknown[],
    selected: unknown[],
    callback: () => Promise<void>
  ) {
    this.dialogState.show = true;
    this.dialogState.title = title;
    this.dialogState.headers = headers as never;
    this.dialogState.items = items as never;
    this.dialogState.selected = selected as never;
    this.dialogState.callback = callback;
  }

  async closeDialog() {
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
    }, 100);
  }

  onDialogChanged() {
    this.dialogState.callback();
  }

  onDialogRowClicked(item: never) {
    const idx = this.dialogState.selected.findIndex(x => x === item);
    if (idx > -1) {
      this.dialogState.selected.splice(idx, 1);
    } else {
      this.dialogState.selected.push(item);
    }
  }
}

@Component
class ExcelImpl extends Mixins(AxPage) {
  dataItem!: DataItem<unknown, State>;

  async onExportExcelConfirm(prefix: string) {
    if (!this.dataItem.description.length) {
      await this.showErrorModal('오류', '조회 후 엑셀 다운로드가 가능합니다');
      return;
    }

    const result = await this.showConfirmModal(
      '확인',
      '검색한 데이터들을 엑셀로 내보냅니다<br />계속하시겠습니까?',
      ['네', '아니오']
    );
    if (result === 0) {
      this.setLoading(true);
      setTimeout(() => this.onExportExcel(prefix), 500);
    }
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };
      console.log(this.dataItem);

      moment.locale('ko');
      const momentTime = moment(Date.now());
      const outputPrefix = `${prefix.replace(/\s/g, '_')}_${this.dataItem.name.replace(
        /\s/g,
        ''
      )}_`;

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      const headers = this.dataItem.store.getHeaders();

      // 엑셀 내보내기시 수작업으로 순번 필드를 만드므로 순번 필드를 삭제시킨다
      const headerEntries = Object.entries(headers).filter(x => x[0] !== 'num');
      const headerKeys = headerEntries.map(x => x[0]);
      const headerValues = headerEntries.map(x => x[1]);

      if (!headers) {
        await this.showErrorModal('확인', '올바르지 않은 테이블 구조입니다');
        return;
      }

      // 헤더 작성 (식수 조회 [사원별] 등등..)
      const headerSize = headerKeys.length;
      worksheet.mergeCells(`A1:${colNames(headerSize)}1`);
      worksheet.getCell('A1').value = `${prefix} [${this.dataItem.name}]`;
      worksheet.getCell('A1').font = { family: 4, size: 18, bold: true };
      worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell('A1').border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      let row = 2;

      // 구역이나 회사 등등은 검색시 만들어둔 description table을 참고한다
      // 검색 당시와 현재 조건이 다를 수 있으므로 이를 보완한 방법
      this.dataItem.description.forEach(x => {
        worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
        worksheet.getCell(`A${row++}`).value = x;
      });

      // 생성 시간은 검색 시간과 무관하게 현재 시간을 기준으로 삼는다

      worksheet.mergeCells(`A${row}:${colNames(headerSize)}${row}`);
      worksheet.getCell(`A${row++}`).value = `생성시간 : ${momentTime.format('YYYY-MM-DD LT')}`;

      worksheet.insertRow(
        row,
        [
          'No.',
          ...headerValues.map(x => {
            if (typeof x === 'string') return x;
            else {
              const y = x as { [key: string]: unknown };
              if (y.text) {
                return y.text;
              } else {
                return y;
              }
            }
          })
        ],
        'i'
      );
      const headerRow = row++;
      // 테두리 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.style = {};
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });

      // 아이템 필터. Header에 들어간 item만 뽑는다
      this.dataItem.store.getItems().forEach((x, idx) => {
        const arr: unknown[] = [idx + 1];
        headerKeys.forEach(y => {
          if (y === 'eventTime') {
            arr.push(this.formatTime((x as { [key: string]: string })[y]));
          } else {
            arr.push((x as { [key: string]: unknown })[y]);
          }
        });
        worksheet.insertRow(row++, arr, 'i');
      });

      // 헤더 라인에 음영 넣기
      worksheet.getRow(headerRow).eachCell(cell => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFBFBFBF' },
          bgColor: { argb: 'FFFFFF00' }
        };

        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = outputPrefix + momentTime.format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }
}

@Component
export class DateImpl extends Vue {
  beginDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  beginDateMenu = false;
  endDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
  endDateMenu = false;

  beginTime = '00:00';
  beginTimeMenu = false;
  endTime = '23:59';
  endTimeMenu = false;

  filterBeginTime = '00:00';
  filterBeginTimeMenu = false;

  filterEndTime = '23:59';
  filterEndTimeMenu = false;
}

@Component
export class AdvSearchImpl extends Mixins(AxPage) {
  isOpenAdvSearch!: boolean;
  dataItem!: DataItem<unknown, State>;

  onToggleAdvSearch() {
    this.isOpenAdvSearch = !this.isOpenAdvSearch;
  }

  async confirmClearAdvSearch(text: string) {
    const result = await this.showConfirmModal('확인', text, ['네', '아니오']);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearAdvSearch() {
    const result = await this.showConfirmModal('확인', '고급 검색 필터를 초기화할까요?', [
      '네',
      '아니오'
    ]);
    if (result === 0) {
      this.dataItem.state = new State();
    }
  }

  async onClearSearch() {
    this.dataItem.search = '';
  }
}

// vue-class-component의 mixins는 생성자가 5개 이상 넘어가면 unknown으로 캐스팅됨
// 이를 방지하기 위해서 여러 클래스를 분할하는 Mixin 패턴을 사용하려면
// 클래스를 5개씩 끊어서 넣어줘야 한다
const MixinClasses = Mixins(
  Mixins(ApiImpl, DataItemImpl, SelectDialogImpl, ExcelImpl, DateImpl),
  Mixins(AdvSearchImpl, AxPage)
);

@Component
export default class HistorySearch extends MixinClasses {
  currentTab: TabKind = TabKind.Access;
  dialogState = new DialogState();
  isOpenAdvSearch = false;

  zoneCode = 0;
  revertZone = false;

  pageInfo: I.UserHistoryPageInfo = {} as I.UserHistoryPageInfo;
  staffList: I.TempStaffHistoryList[] = [];

  listControl: I.SelectData[] = [
    { icon: '1', text: '출입문 제어' },
    { icon: '1', text: '출입문 제어1' },
    { icon: '1', text: '출입문 제어2' }
  ];

  async prepare() {
    const baseData = await this.getBaseData();
    console.log(baseData);
    if (baseData) {
      this.pageInfo = baseData;

      // TODO: 이벤트 검색 구역 선택 State 저장
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }

  async getBaseData() {
    const result = await this.API.call.user.getUserHistoryPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  dates = [];

  makeHistoryPacket(): I.PacketHistorySearch {
    return {
      listCompanyCode: this.dataItem.state.listCompanyCode,
      listDeptCodeA: this.dataItem.state.listDeptCodeA,
      listDeptCodeB: this.dataItem.state.listDeptCodeB,
      listUserStatus: this.dataItem.state.listUserStatus,
      dateFrom: `${this.beginDate}T${this.beginTime}:00.000Z`,
      dateTo: `${this.endDate}T${this.endTime}:00.000Z`,
      uid: this.dataItem.state.cardNo,
      name: this.dataItem.state.userName,
      empNo: this.dataItem.state.empno
    };
  }

  onSearchHistory() {
    return this.onUserSearchHistory();
  }

  async onUserSearchHistory() {
    const result = await this.execHistorySearch(this.makeHistoryPacket());
    if (result) {
      this.dataItem.store.setItems(result);
      this.dataItem.description = [];
      this.dataItem.description.push(
        `조회기간 : ${this.beginDate} ${this.beginTime} ~ ${this.endDate} ${this.endTime}`
      );

      this.dataItem.description.push(
        `구역 : ${this.getZoneList().find(x => x.code === this.zoneCode)?.name ||
          '(Code ' + this.zoneCode + ')'}`
      );

      // 엑셀 출력시 description 테이블을 참조해 세부 내용들을 생성한다
      const { listCompanyCode, listDeptCodeA, listDeptCodeB, listUserStatus } = this.dataItem.state;

      if (this.dataItem.search.length > 0) {
        this.dataItem.description.push(`키워드 : ${this.dataItem.search}`);
      }

      if (this.dataItem.state.empno.length > 0) {
        this.dataItem.description.push(`사원번호 : ${this.dataItem.state.empno}`);
      }

      if (this.dataItem.state.userName.length > 0) {
        this.dataItem.description.push(`이름 : ${this.dataItem.state.userName}`);
      }

      if (listCompanyCode.length) {
        this.dataItem.description.push(`회사 : ${listCompanyCode.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeA.length) {
        this.dataItem.description.push(`사업장 : ${listDeptCodeA.map(x => x.name).join(', ')}`);
      }

      if (listDeptCodeB.length) {
        this.dataItem.description.push(`부서 : ${listDeptCodeB.map(x => x.name).join(', ')}`);
      }

      if (listUserStatus.length) {
        this.dataItem.description.push(`상태 : ${listUserStatus.map(x => x.name).join(', ')}`);
      }
    }
  }
}
